import React from "react";
import { SearchIcon } from "@heroicons/react/solid";
import ReactTooltip from "react-tooltip";

function SearchBar(props) {
  return (
    <div className="hidden md:block w-full">
      <div className=" h-16 flex  items-center px-5  bg-background">
        <ReactTooltip delayShow={500} delayHide={100} />
        <div
          className="relative items-center w-full"
          data-tip="Enter text to search"
          data-place="bottom"
        >
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            <SearchIcon
              className="absolute  h-6 w-6 text-palette_color1"
              aria-hidden="true"
            />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            autoComplete="off"
            className="font-robo block text-sm w-full pl-10 py-2 px-3 bg-palette_color2 text-primary appearance-none border-[1px] border-palette_color1 rounded-xl placeholder-secondary focus:outline-none focus:z-10 sm:text-sm"
            placeholder="Search"
            onChange={(e) => props.getRecentSearchText(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
